import styled from 'styled-components';
import { ACTIVE_BOX_SHADOW } from 'components/ButtonBase';
import IconButton from 'components/IconButton';
import ProgressRing from 'components/ProgressRing';
import { Pause, Play } from 'icons';
import { getThemeColor } from 'utils/styled';
import { StyleProps } from './types';

const OUTER_BOX_SHADOW = `0 2px 30px 0 rgba(0, 0, 0, 0.5)`;

export const Root = styled.div<StyleProps>`
  height: 64px;
  position: relative;
  transition: ${({ theme }) => theme.transitions.create('transform', '300ms')};
  width: 64px;

  &[data-hovered='true'] {
    transform: ${({ $playing }) => !$playing && 'scale(1.09)'};
  }

  * {
    color: ${getThemeColor('white')};
  }
`;

export const Button = styled(IconButton)<StyleProps>`
  box-shadow: ${OUTER_BOX_SHADOW};
  border: 2px solid ${getThemeColor('white')};
  height: 100%;
  transition: ${({ theme, $playing }) =>
    theme.transitions.create('border-color', $playing ? '600ms' : '0ms')};
  width: 100%;

  &:active:not([disabled]) {
    box-shadow: ${ACTIVE_BOX_SHADOW}, ${OUTER_BOX_SHADOW};
  }

  &,
  ${Root}[data-hovered='true'] & {
    background-color: rgba(0, 0, 0, 0.5);
  }

  ${({ $duration, $playing, theme }) => {
    if ($duration !== undefined) {
      return `
        border-color: ${$playing ? 'transparent' : theme.palette.common.white};
      `;
    }
    return undefined;
  }}
`;

export const PlayIcon = styled(Play)`
  height: auto;
  margin-left: 5px;
  margin-top: 1px;
  width: 21px;
`;

export const PauseIcon = styled(Pause)`
  height: auto;
  width: 24px;
`;

export const Progress = styled(ProgressRing)`
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;

  .rc-progress-circle-path {
    transition: none !important;
  }
`;
